import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class TooManyRequestsInterceptor implements HttpInterceptor {

  constructor(private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse) {
            if(event.status == 429) {
              this.router.navigate(["/429"]);
            }
          }
          return event;
        },
        error: (error) => {
          if(error.status === 429) {
            this.router.navigate(["/429"]);
          }
        }
      }));
  }
}